import React from 'react';

import FieldConfigurationCard from '~/components/SystemConfiguration/FnolConfiguration/FnolConfigurationScreen/FieldConfigurationCard/FieldConfigurationCard';
import BaseConfigurationSection from '~/components/SystemConfiguration/FnolConfiguration/FnolConfigurationScreen/Sections/BaseConfigurationSection';
import type { ConfigurationField } from '~/components/SystemConfiguration/IncidentConfigurationPage/types';

import SystemFieldConfigurationCard from '../../SystemFieldConfigurationCard/SystemFieldConfigurationCard';

interface SystemFieldsSectionProps {
  fields: ConfigurationField[];
  subtitle: string;
  // The Broker pre-defined field lives once on Policy Details. Covered-object sections
  // reuse this component for their own system fields and must not re-render it (it binds
  // to the single configuration.policy.pre_defined_fields.broker_contact_id).
  includeBrokerField?: boolean;
}

const BROKER_PREDEFINED_FIELD_ID = 'broker_contact_id';
const BROKER_ID_PREFIX = 'configuration.policy.pre_defined_fields';

const SystemFieldsSection: React.FC<SystemFieldsSectionProps> = ({ fields, subtitle, includeBrokerField = false }) => {
  return (
    <BaseConfigurationSection
      title={`System Fields (${fields.length + (includeBrokerField ? 1 : 0)})`}
      subtitle={subtitle}
      withActionsContainerFullWidth={false}
    >
      {fields.map((field) => (
        <SystemFieldConfigurationCard field={field} key={field.id} />
      ))}
      {includeBrokerField && (
        <FieldConfigurationCard
          idPrefix={BROKER_ID_PREFIX}
          fieldId={BROKER_PREDEFINED_FIELD_ID}
          disableType
          hideCategories
          contactRolesEditable
          requiredLabel="Required"
        />
      )}
    </BaseConfigurationSection>
  );
};

export default SystemFieldsSection;
